import type { TFunction } from "i18next"
import { FC } from "react"
import { matchPath, useLocation } from "react-router-dom"
import { MenuEntry } from "./MenuEntry"
import { useMenuEntry } from "./useMenuEntry"

type MenuEntryListProps = {
  t: TFunction
  isAdmin: boolean
  isTeamLeader: boolean
}

export const MenuEntryList: FC<MenuEntryListProps> = ({ t, isAdmin, isTeamLeader }) => {
  const location = useLocation()
  const { filteredMenuEntries } = useMenuEntry(isAdmin, isTeamLeader)

  return filteredMenuEntries.map(entry => {
    const pathWithoutAnchor = entry.path.split("#")[0]
    const isSubPathOfExistingRoute = matchPath({ path: `${pathWithoutAnchor}/*` }, location.pathname) !== null
    return (
      <MenuEntry
        key={entry.path}
        content={t(entry.displayNameKey)}
        iconName={entry.iconName}
        goTo={entry.path}
        isActive={location.pathname === pathWithoutAnchor || isSubPathOfExistingRoute}
        isDisabled={Boolean(entry.isDisabled)}
        tooltip={entry.tooltip ? t(entry.tooltip) : ""}
      />
    )
  })
}
